import { BaseHTMLElement } from "../BaseHTMLElement";

export class Toolbar extends BaseHTMLElement {
    constructor(className?: string) {
        super('div', className || 'toolbar');
    }

    public addTool(tool: BaseHTMLElement): this {
        this.element.appendChild(tool.getElement());
        return this;
    }

    public addTools(...tools: BaseHTMLElement[]): this {
        tools.forEach(tool => this.addTool(tool));
        return this;
    }
}
